<template>
  <div>

  <LoginForm v-if="!loggedIn" />
  <br/>
  <Content name="welcome" />
  <br/>

  </div>
</template>

<script>
import LoginForm from './LoginForm'
import { mapGetters } from 'vuex'
import Content from './Content.vue'

export default {
    components: {
        LoginForm,
        Content
    },
    data: function() {
        return {
            content : 'Some starter content',
        }
    },
    computed: {
      ...mapGetters([
        'loggedIn',
        'uuid',
        'email'
      ])
        },
    methods: {},
}
</script>

<styles scoped>
</styles>
